import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Text,
  Button,
  HStack,
  Stack,
  Center,
} from "@chakra-ui/react";
import { Link, Route, Switch, useHistory } from "react-router-dom";
import CreatePrograms from "./CreatePrograms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import programs from "../../lib/programs.json";
import { Spinner } from "react-bootstrap";
import CreateHandout from "../programs/handout/CreateHandout";

const Programs = () => {
  let loading = false; //temporary till the api is ready
  const history = useHistory();
  // const [loading, setLoading] = useState(false);
  // const [services, setServices] = useState([]);
  const [programsData, setProgramsData] = useState([]);
  let programBasePath = "/dashboard/knowledge-bank/programs";
  let handoutBasePath = "/dashboard/knowledge-bank/programs/handout";

  useEffect(() => {
    setProgramsData(programs);
  }, []);

  const [creatingProgram, setCreatingProgram] = useState(false);
  const [creatingHandBook, setCreatingHandBook] = useState(false);
  const [activeIndex, setActiveIndex] = useState("");

  useEffect(() => {
    let { pathname } = history.location;
    let id = pathname.split("/")[4];

    // check if the path is for creating a new program
    // it's either you are creating a new program or editing, this allows to deduce which so as to properly highlight the data
    if (id === "new") {
      setCreatingProgram(true);
      setActiveIndex();
    } else {
      setCreatingProgram(false);

      let index = programs.findIndex((program) => program._id === id);
      setActiveIndex(index);
    }
  }, [history.location]);

  useEffect(() => {
    let { pathname } = history.location;
    let id = pathname.split("/")[4];

    if (id === "handout") {
      setCreatingHandBook(true);
    } else {
      setCreatingHandBook(false);
    }
    // check if the path is for creating a new program
    // it's either you are creating a new program or editing, this allows to deduce which so as to properly highlight the data
  }, [history.location]);

  const initCreateNew = (path) => {
    history.push(`${path}/new`);
  };

  return (
    <Grid
      sx={{
        gridTemplateAreas: "'top' 'bottom'",
        height: "100%",
        gridTemplateRows: "auto 1fr",
      }}
    >
      <Box sx={{ gridArea: "top", px: "8", py: "6" }}>
        <HStack
          gap="4"
          alignItems="center"
          onClick={() => history.push("/dashboard/knowledge-bank/")}
          color="#00A2E7"
          sx={{
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
          <Text>Knowledge Bank</Text>
        </HStack>

        <Text sx={{ fontSize: "22px", fontWeight: "bold", mt: 4 }}>
          Programs
        </Text>
      </Box>
      <Grid sx={{ gridArea: "bottom" }} templateColumns="1fr 3fr">
        <Box>
          <Stack gap={4} mb={3}>
            <Button
              backgroundColor={creatingProgram && "#00A2E7"}
              sx={{ borderRadius: 0 }}
              color={creatingProgram ? "white" : "black"}
              isFullWidth
              onClick={() => initCreateNew(programBasePath)}
            >
              Create new Program
            </Button>

            <Button
              backgroundColor={creatingHandBook && "#00A2E7"}
              sx={{ borderRadius: 0 }}
              color={creatingHandBook ? "white" : "black"}
              isFullWidth
              onClick={() => initCreateNew(handoutBasePath)}
            >
              Create new Handout
            </Button>
          </Stack>

          <Box>
            <Text color="#00A2E7" sx={{ fontWeight: "bold" }} px="8" py="6">
              My Programs
            </Text>
            {loading ? (
              <h2 style={{ textAlign: "center" }}>Loading...</h2>
            ) : (
              programsData.map((tab, i) => (
                <Link key={`data${i}`} to={`${programBasePath}/${tab._id}`}>
                  <Box
                    sx={{
                      border: "1px solid #DAE0EA",
                      px: 6,
                      py: 3,
                      cursor: "pointer",
                    }}
                    bg={i === activeIndex && "#00A2E7"}
                  >
                    <Text
                      sx={{
                        fontWeight: "500",
                        fontSize: "18px",
                        textDecoration: "none",
                        textTransform: "capitalize",
                      }}
                    >
                      {tab.title}
                    </Text>
                  </Box>
                </Link>
              ))
            )}
          </Box>
        </Box>
        <Box
          style={{
            border: "1px solid #DAE0EA",
          }}
        >
          <Switch>
            {/* base */}
            <Route path={programBasePath} exact>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDir="column"
                mt="6rem"
              >
                <Text color="#00A2E7" fontSize="1.5rem" px="8" py="6">
                  Select a Program from sidebar to manage
                </Text>
                <Button
                  onClick={() => initCreateNew(programBasePath)}
                  backgroundColor="#00A2E7"
                  color="#fff"
                >
                  Create a new Program
                </Button>
              </Box>
            </Route>

            {/* /new */}
            <Route path={`${programBasePath}/new`} exact>
              <CreatePrograms />
            </Route>

            <Route path={`${handoutBasePath}/new`} exact>
              <CreateHandout />
            </Route>

            {/* edit /:id */}
            <Route path={`${programBasePath}/:id`}>
              <EditContent />
            </Route>
          </Switch>
        </Box>
      </Grid>
    </Grid>
  );
};

const EditContent = () => {
  const history = useHistory();
  const [program, setProgram] = useState({});

  useEffect(() => {
    let { pathname } = history.location;
    let id = pathname.split("/")[4];

    let activeProgram = programs.filter((program) => program._id === id)[0];

    setProgram(activeProgram);
  }, [history.location]);

  return (
    <>
      {Object.keys(program).length > 0 ? (
        <CreatePrograms program={program} />
      ) : (
        <Center>
          <Spinner />
        </Center>
      )}
    </>
  );
};

export default Programs;
